<h2 class="border_btm">Medical Officer Action</h2>
<form [formGroup]="OpdDocsForm" (submit)="updateData()">
    <div class="col-sm-12 radiobox box_min_height">
        <div class="col-sm-12 radiobox">
            <mat-radio-group aria-label="Select an option" (change)="assigedAction($event.value)" formControlName="doc_approved_status">
                <mat-radio-button [value]="1">Approved</mat-radio-button>
                <mat-radio-button [value]="2">Rejected</mat-radio-button>
                <mat-radio-button [value]="3">High Risk</mat-radio-button>
                <mat-radio-button [value]="4">Low Risk</mat-radio-button>
            </mat-radio-group>
        </div>
        <div *ngIf="submitted && f.doc_approved_status.errors" class="invalid-feedback">
            <div *ngIf="f.doc_approved_status.errors.required">Please choose atleast one option.</div>
        </div>
        <div class="col-sm-12 radiobox" *ngIf="showTextBox">
            <div class="form-group">
                <label class="form-label">Comments</label>
                <textarea class="form-control" formControlName="comments"></textarea>
            </div>
        </div>
    </div>

    <div class="col-sm-12 radiobox card-footer">
        <button type="submit" [disabled]="loading" class="btn btn-primary float-right" style="margin-left: 15px;" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
        <!-- <button type="submit" class="btn btn-primary float-right" style="margin-left: 15px;"> Update</button> -->
        <button type="button" class="btn btn-default float-right" (click)="CloseModal();">Close</button>
    </div>
</form>



